import app from "flarum/forum/app";
import Notification from "flarum/forum/components/Notification";
import { channelIdOf, channelNameOf, fromName, openChannelFromNotification } from "./ModeratorPromotedNotification";

/**
 * "X left #channel, so you are now its owner."
 *
 * Sent to the oldest moderator when a channel's owner leaves and it passes to
 * them (Service\OwnershipSuccession). Nobody asked them, so they need telling:
 * the room's settings, members and its fate are theirs now.
 */
export default class OwnershipInheritedNotification extends Notification {
  icon() {
    return "fas fa-crown";
  }
  href() {
    const channelId = channelIdOf(this);
    return channelId ? app.route("chat.channel", {
      id: channelId
    }) : app.route("chat.index");
  }
  content() {
    return app.translator.trans("ramon-chat.forum.notifications.ownership_inherited", {
      username: fromName(this),
      channel: channelNameOf(this)
    });
  }
  excerpt() {
    return null;
  }
  onclick(e) {
    openChannelFromNotification(this, e);
  }
}
flarum.reg.add('ramon-chat', 'forum/components/OwnershipInheritedNotification', OwnershipInheritedNotification);